import React from 'react';
import { Button,Table,Modal } from 'antd';
import { withRouter } from 'react-router-dom';
import abortAjaxHoc from 'components/abortAjaxHoc';
import ControlSeparator from 'components/ControlSeparator';
import {Link} from 'react-router-dom';

const confirm = Modal.confirm;

class RoleManagement extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            list:[],
            loading:true
        };
        this.columns = [{
            title: 'Role',
            dataIndex: 'name',
            key: 'name',
            width:200
        }, {
            title: 'Description',
            dataIndex: 'desc',
            key: 'desc'
        }, {
            title: 'Permissions',
            dataIndex: 'permission_count',
            key: 'permission_count',
            width:200,
            render(text){
                return text+' permissions';
            }
        }, {
            title: 'Sub-accounts',
            dataIndex: 'sub_account_count',
            key: 'sub_account_count',
            width:150
        }, {
            title: 'Actions',
            dataIndex: 'id',
            key: 'id',
            width:300,
            render:(text,r,index)=>{
                return <ControlSeparator>
                    <Link to={'/pages/edit-role/'+text}>Edit</Link>
                    <Link to={'/pages/role/'+text+'/manage-member'}>Manage Members</Link>
                    <a onClick={this.onDelete.bind(this,text,index)}>Delete</a>
                </ControlSeparator>;
            }
        }];
    }

    componentDidMount(){
        this.getRoleList();
    }

    getRoleList(){
        this.setState({loading:true});
        this.props.abortableAjax('GET','/roles').then(res=>{
            this.setState({list:res.data,loading:false});
        });
    }



    onDelete(id,index){
        confirm({
            title: 'Confirm Deletion',
            content: 'Deleted roles cannot be recovered. Are you sure you want to delete?',
            onOk:()=>{
                //'/roles/'+id
                return this.props.abortableAjax('DELETE','/roles/'+id).then(()=>{
                    this.getRoleList();
                });
            },
            onCancel() {}
        });
    }

    onCreate(){
        const { history } = this.props;
        history.push('/pages/create-role');
    }

    render(){
        const {loading,list} = this.state;
        return <div>
            <p className='sub-account-tips'>Roles are collections of permissions. You can create roles - such as "Developer" or "Operations" - according to your organization's or business's needs to bind a set of permissions.<br/>Then you can assign roles to sub-accounts for more intuitive and convenient sub-account authorization.</p>
            <Button style={{'margin':'20px 0'}} type="primary" onClick={this.onCreate.bind(this)}>Create Role</Button>
            <Table
                columns={this.columns}
                rowKey='id'
                pagination={false}
                loading={loading}
                dataSource={list}/>
        </div>;
    }
}



export default abortAjaxHoc(withRouter(RoleManagement));



// WEBPACK FOOTER //
// ./src/pages/roleManagenment/RoleManagement.js